import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'clients';

export default {
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async getByPhone(phone) {
    const url = mountUrl(`/client`, { phone });
    return api.get(url);
  },
  async update(id, data) {
    const url = mountUrl(`/client/${id}/update`);
    return api.patch(url, data);
  },
  async updatePhone(id, data) {
    const url = mountUrl(`/client/${id}/phone`);
    return api.patch(url, data);
  }
};
